// src/config.ts

export const API_URL = window.location.hostname === 'localhost'
    ? 'http://localhost:8001'
    : 'https://woda.gruta.pl/api'; // API i frontend pod jedną domeną

// Opcjonalnie: stwórz gotową instancję axios, żeby nie pisać URL za każdym razem
import axios from 'axios';

export const api = axios.create({
    baseURL: API_URL
});